import React from 'react';

import Table from 'components/Table/Table';
import { Close } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { TextField } from '@material-ui/core';
import { onlyInteger } from 'hooks/Pipe';

export default function GroupSaleProduct({
  sellGroup,
  deleteSellProduct,
  updateSaleProduct,
  statePromo,
}) {
  return (
    <Table
      striped
      tableHead={['#', 'Código', 'Nombre', 'Requerido', 'Eliminar']}
      tableData={sellGroup.products.map((product, i) => {
        return [
          i + 1,
          product.item_code,
          product.item_name,
          <TextField
            type="number"
            onKeyPress={onlyInteger}
            key={product.required}
            defaultValue={product.required}
            onBlur={(e) => updateSaleProduct(product.id, e.target.value)}
            inputProps={{ min: 0, max: 999 }}
            disabled={statePromo}
          />,
          <Button
            round
            size="sm"
            justIcon
            color="danger"
            onClick={() => deleteSellProduct(product)}
            disabled={statePromo}
          >
            <Close />
          </Button>,
        ];
      })}
    />
  );
}
